module.exports = __webpack_public_path__ + "bin/97a9472fee6c2cb323c2399bd6192bdf.jpg";